import {
	CancelPaymentStatus,
	CancelType,
} from "@/main/gql/__generated__/graphql"

export const showEditButton = (paymentStatus: CancelPaymentStatus): boolean => {
	return paymentStatus === "INVOICE_NOT_SENT"
}

export const isValidCancelTypeToSendInvoice = (
	cancelType: CancelType
): boolean => {
	// 厳密には 2日以上前など、他にも送れないことあるが、そのケースは今回関係ないので、UNSPECIFIED 以外は送れるとする
	return cancelType !== "UNSPECIFIED"
}
